import { createAction, props } from '@ngrx/store';

import { IUser } from '@shared/types';
import { ICompany, ICompanyRole, IUserPermissions } from '@shared/types/session';

export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN';
export const GET_ACCESS_TOKEN_SUCCESS = 'GET_ACCESS_TOKEN_SUCCESS';
export const GET_ACCESS_TOKEN_FAILURE = 'GET_ACCESS_TOKEN_FAILURE';

export const GET_ACCESS_TOKEN_FOR_NO_IFRAME = 'GET_ACCESS_TOKEN_FOR_NO_IFRAME';
export const GET_ACCESS_TOKEN_FOR_NO_IFRAME_SUCCESS = 'GET_ACCESS_TOKEN_FOR_NO_IFRAME_SUCCESS';
export const GET_ACCESS_TOKEN_FOR_NO_IFRAME_FAILURE = 'GET_ACCESS_TOKEN_FOR_NO_IFRAME_FAILURE';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const LOG_OUT = 'LOG_OUT';
export const LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS';

export const CHECK_USER_AUTH = 'CHECK_USER_AUTH';
export const CHECK_USER_AUTH_SUCCESS = 'CHECK_USER_AUTH_SUCCESS';
export const CHECK_USER_AUTH_FAILURE = 'CHECK_USER_AUTH_FAILURE';

export const LOCAL_CHECK_USER_AUTH = 'LOCAL_CHECK_USER_AUTH';
export const LOCAL_CHECK_USER_AUTH_SUCCESS = 'LOCAL_CHECK_USER_AUTH_SUCCESS';
export const LOCAL_CHECK_USER_AUTH_FAILURE = 'LOCAL_CHECK_USER_AUTH_FAILURE';

export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAILURE = 'FETCH_COMPANIES_FAILURE';

export const TOKEN_RETRIEVED = 'TOKEN_RETRIEVED';
export const SET_IFRAME_MODE = 'SET_IFRAME_MODE';

export const RESTORE_TOKEN = 'RESTORE_TOKEN';
export const RESTORE_TOKEN_SUCCESS = 'RESTORE_TOKEN_SUCCESS';
export const RESTORE_TOKEN_FAILURE = 'RESTORE_TOKEN_FAILURE';

export const GET_COMPANY_ROLES = 'GET_COMPANY_ROLES';
export const GET_COMPANY_ROLES_SUCCESS = 'GET_COMPANY_ROLES_SUCCESS';
export const GET_COMPANY_ROLES_FAILURE = 'GET_COMPANY_ROLES_FAILURE';

export const GET_COMPANY_LANG = 'GET_COMPANY_LANG';
export const GET_COMPANY_LANG_SUCCESS = 'GET_COMPANY_LANG_SUCCESS';
export const GET_COMPANY_LANG_FAILURE = 'GET_COMPANY_LANG_FAILURE';

export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const GET_PERMISSIONS_FAILURE = 'GET_PERMISSIONS_FAILURE';

export const SHOW_COMPANY_SELECTOR = 'SHOW_COMPANY_SELECTOR';
export const HIDE_COMPANY_SELECTOR = 'HIDE_COMPANY_SELECTOR';

export const SET_SESSION_READY = 'SET_SESSION_READY';

export const INIT_COMPANY_SESSION = 'INIT_COMPANY_SESSION';

export const FETCH_COMPANY_INFO = 'FETCH_COMPANY_INFO';
export const FETCH_COMPANY_INFO_SUCCESS = 'FETCH_COMPANY_INFO_SUCCESS';
export const FETCH_COMPANY_INFO_FAILURE = 'FETCH_COMPANY_INFO_FAILURE';

export const get_user = createAction(`[SESSION_REDUCER] ${GET_USER}`);
export const get_user_failure = createAction(`[SESSION_REDUCER] ${GET_USER_FAILURE}`);
export const get_user_success = createAction(
    `[SESSION_REDUCER] ${GET_USER_SUCCESS}`,
    props<{ user: IUser; companyId: string }>(),
);

export const user_login = createAction(
    `[SESSION_REDUCER] ${USER_LOGIN}`,
    props<{ user: Readonly<string>; password: Readonly<string> }>(),
);
export const user_login_failure = createAction(`[SESSION_REDUCER] ${USER_LOGIN_FAILURE}`);
export const user_login_success = createAction(
    `[SESSION_REDUCER] ${USER_LOGIN_SUCCESS}`,
    props<{ token: Readonly<string>; companyId: string }>(),
);

export const get_access_token = createAction(`${GET_ACCESS_TOKEN}`, props<{ companyId: Readonly<string> }>());
export const get_access_token_failure = createAction(`${GET_ACCESS_TOKEN_FAILURE}`);
export const get_access_token_success = createAction(`${GET_ACCESS_TOKEN_SUCCESS}`, props<{ token: string }>());

export const get_access_token_for_no_iframe = createAction(
    `${GET_ACCESS_TOKEN_FOR_NO_IFRAME}`,
    props<{ companyId: Readonly<string> }>(),
);
export const get_access_token_for_no_iframe_failure = createAction(`${GET_ACCESS_TOKEN_FOR_NO_IFRAME_FAILURE}`);
export const get_access_token_for_no_iframe_success = createAction(
    `${GET_ACCESS_TOKEN_FOR_NO_IFRAME_SUCCESS}`,
    props<{ token: string; companyId: string; user: IUser }>(),
);

export const check_user_auth = createAction(`[SESSION_REDUCER] ${CHECK_USER_AUTH}`);
export const check_user_auth_failure = createAction(`[SESSION_REDUCER] ${CHECK_USER_AUTH_FAILURE}`, props<{ null }>());
export const check_user_auth_success = createAction(
    `[SESSION_REDUCER] ${CHECK_USER_AUTH_SUCCESS}`,
    props<{ user: Readonly<IUser>; token: Readonly<string>; companyId: string }>(),
);

export const local_check_user_auth = createAction(`[SESSION_REDUCER] ${LOCAL_CHECK_USER_AUTH}`);
export const local_check_user_auth_failure = createAction(
    `[SESSION_REDUCER] ${LOCAL_CHECK_USER_AUTH_FAILURE}`,
    props<{ null }>(),
);
export const local_check_user_auth_success = createAction(
    `[SESSION_REDUCER] ${LOCAL_CHECK_USER_AUTH_SUCCESS}`,
    props<{ user: Readonly<IUser>; token: Readonly<string>; companyId: string }>(),
);

export const log_out = createAction(`[SESSION_REDUCER] ${LOG_OUT}`);
export const log_out_success = createAction(`[SESSION_REDUCER] ${LOG_OUT_SUCCESS}`);

export const set_iframe_mode = createAction(
    `[SESSION_REDUCER] ${SET_IFRAME_MODE}`,
    props<{ isIframeMode: Readonly<boolean> }>(),
);
export const set_token = createAction(`[SESSION_REDUCER] ${TOKEN_RETRIEVED}`, props<{ token: Readonly<string> }>());

export const fetch_companies = createAction(`${FETCH_COMPANIES}`);
export const fetch_companies_failure = createAction(`${FETCH_COMPANIES_FAILURE}`);
export const fetch_companies_success = createAction(`${FETCH_COMPANIES_SUCCESS}`, props<{ items: Array<ICompany> }>());

export const get_permissions = createAction(`[SESSION_REDUCER] ${GET_PERMISSIONS}`);
export const get_permissions_failure = createAction(`[SESSION_REDUCER] ${GET_PERMISSIONS_FAILURE}`);
export const get_permissions_success = createAction(
    `[SESSION_REDUCER] ${GET_PERMISSIONS_SUCCESS}`,
    props<{ permissions: IUserPermissions }>(),
);

export const get_company_roles = createAction(
    `[SESSION_REDUCER] ${GET_COMPANY_ROLES}`,
    props<{ user: Readonly<IUser>; companyId: Readonly<string> }>(),
);

export const get_company_roles_failure = createAction(`[SESSION_REDUCER] ${GET_COMPANY_ROLES_FAILURE}`);
export const get_company_roles_success = createAction(
    `[SESSION_REDUCER] ${GET_COMPANY_ROLES_SUCCESS}`,
    props<{ companyRoles: Array<ICompanyRole> }>(),
);

export const get_company_lang = createAction(
    `[SESSION_REDUCER] ${GET_COMPANY_LANG}`,
    props<{ companyId: Readonly<string> }>(),
);

export const get_company_lang_failure = createAction(`[SESSION_REDUCER] ${GET_COMPANY_LANG_FAILURE}`);
export const get_company_lang_success = createAction(
    `[SESSION_REDUCER] ${GET_COMPANY_LANG_SUCCESS}`,
    props<{ preferred_language: string }>(),
);

export const show_company_selector = createAction(`[SESSION_REDUCER] ${SHOW_COMPANY_SELECTOR}`);
export const hide_company_selector = createAction(`[SESSION_REDUCER] ${HIDE_COMPANY_SELECTOR}`);

export const restore_token = createAction(
    `[SESSION_REDUCER] ${RESTORE_TOKEN}`,
    props<{ token: string; user: IUser }>(),
);
export const restore_token_success = createAction(
    `[SESSION_REDUCER] ${RESTORE_TOKEN_SUCCESS}`,
    props<{ token: string; user: any; companyId: string }>(),
);
export const restore_token_failure = createAction(`[SESSION_REDUCER] ${RESTORE_TOKEN_FAILURE}`);

export const set_session_ready = createAction(`[SESSION_REDUCER] ${SET_SESSION_READY}`);

export const init_company_session = createAction(
    `[SESSION_REDUCER] ${INIT_COMPANY_SESSION}`,
    props<{ companyId: Readonly<string>; user: Readonly<IUser> }>(),
);

export const fetch_company_info = createAction(`${FETCH_COMPANY_INFO}`);
export const fetch_company_info_failure = createAction(`${FETCH_COMPANY_INFO_FAILURE}`);
export const fetch_company_info_success = createAction(
    `${FETCH_COMPANY_INFO_SUCCESS}`,
    props<{ items: Array<ICompany> }>(),
);
